export const DAYS_UNTIL_FORCED_INTO_SIDEBAR = 120;
export const DAYS_UNTIL_CONFIRMATION_REQUESTED_AGAIN = 60;
